import zPage from '../Page/page.vue';
export default{
    name:'Communication',
    data(){
        return{
            formInline:{},
            page:{
              targetPage:1,
              pageSize:10,
              totalPage:6,
              type:2,
            },
            areaList:[],
            jlzxList:[],
            totalNumber:0,
            orgCode:'',
            titleName:'',
            provinces:[],
            region:'',
        }
    },
    components:{
        zPage,
    },
    created(){
      this.getData();
      this.getJLZXNum();
      this.getProvinces();
    },
    methods:{
      getData(){
        var body={
          province:this.region,
          pageNumber:this.page.targetPage-1,
          pageSize:this.page.pageSize,
          titleName:this.titleName,
        };
        this.get(this.api.getJLZXDetailList,body).then(res=>{
          if(res.result==200){
            this.page.totalPage=res.data.totalElements;
            this.jlzxList=res.data.list;
            for(var i =0;i<this.jlzxList.length;i++){
              this.jlzxList[i].createDate=this.jlzxList[i].createDate.substring(0,10);
            }
          }
        }).catch();
      },

      handleRowClick (row) {
        // if(this.isLogin()){
          this.$router.push({ path: '/communicationDetail',query: {id:row.id}});
        // }
        
      },
      getJLZXNum(){
        this.get(this.api.getJLZXNum).then(res=>{
          if(res.result==200){
            this.areaList=res.data;
            for(var i=0;i<this.areaList.length;i++){
              this.totalNumber += this.areaList[i].num;
            }
          }
        }).catch();
      },
      getProvinces(){
        this.get(this.api.getProvinces).then(res=>{
          if(res.result==200){
            this.provinces=res.data;
          }
        }).catch();
      },
    }
}